"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'MyImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    previewSrcList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 是否需要token权限的资源
    withtoken: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    sasToken: function sasToken() {
      return this.$store.getters.sasToken;
    },
    formatSrc: function formatSrc() {
      if (this.src && this.withtoken) {
        // console.log('image', `${this.src}&token=${this.sasToken}`)
        return "".concat(this.src, "&token=").concat(this.sasToken);
      } else {
        return this.src;
      }
    },
    formatPreviewSrcList: function formatPreviewSrcList() {
      var _this = this;
      if (!this.src) {
        return [];
      } else if (this.withtoken) {
        return this.previewSrcList.map(function (url) {
          return "".concat(url, "&token=").concat(_this.sasToken);
        });
      } else {
        return this.previewSrcList;
      }
    }
  }
};